import {connect} from "react-redux";
import PostProcessSettings from "../../components/Configurator/Sidebar/PostProcessSettings/PostProcessSettings";

const mapStateToProps = (state) => {
    return {
        api: state.sceneConfig.api,
        config: state.sceneConfig.config,
        geometry: state.sceneConfig.geometry,
        materials: state.sceneConfig.materials,
        arSettings: state.sceneConfig.arSettings,
        annotation: state.sceneConfig.annotation,
        enableAnnotations: state.sceneConfig.enableAnnotations,
        userPermission: state.user.userPermission,
        sharpnessStatus: state.sceneConfig.sharpnessStatus
    }
}

export default connect(mapStateToProps, null)(PostProcessSettings)